// Shared helpers for the SSO deep-link redirect (?sso= / ?next=).

// Key used to hand the post-SSO destination from the auth redirect listener to
// PublicRoute, so its default redirect to Home doesn't override it.
export const POST_SSO_REDIRECT_KEY = 'postSsoRedirect';

// Only relative, single-slash paths are allowed as redirect targets. This blocks
// protocol-relative (//host) and absolute URLs, i.e. open-redirect attempts.
export const isSafeInternalPath = (
  path: string | null | undefined
): path is string =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

// Resolve where to send the user after login, preferring an explicit ?next= on
// the URL (deep-link while already signed in) over a destination carried
// through SSO (stored by the redirect listener). Returns null when neither is safe.
export const resolvePostLoginRedirect = (
  urlNext: string | null | undefined,
  storedNext: string | null | undefined
): string | null => {
  if (isSafeInternalPath(urlNext)) return urlNext;
  if (isSafeInternalPath(storedNext)) return storedNext;
  return null;
};
